
export function getCurrentBrand(): string {
    const hostname = window.location.hostname;

    // Normalize hostname by removing www. and converting to lowercase
    const host = hostname.replace("www.", "").toLowerCase();

    // Map known domains to backend brand IDs
    if (host.includes("diytruckmech")) return "diytruckmech";
    if (host.includes("diymotomech")) return "diymotomech";
    if (host.includes("diyatvmech")) return "diyatvmech";
    if (host.includes("diy-hvac")) return "diy-hvac";
    if (host.includes("diy-electronics")) return "diy-electronics";
    if (host.includes("diy-appliance")) return "diy-appliance";
    if (host.includes("diy-mech")) return "diy-mech";

    // Default fallback
    return "diycarmech";
}
